window.FWSchoolDropdown = window.FWSchoolDropdown || {};

var institutionSelect = (function(config) {

    const $form = $('#select-institution');
    const $institutionsSectionDropdown = $('.institutions--section-dropdown');
    const $institutionDropdown = $('#institutionDropdown');
    const $institutionDropdownDefaultOption = $('#institutionDropdown > option:first-child').clone()[0];

    const $countryDropdown = $('#countryDropdown');

    const initInstitutionDropdown = function(data = [], disabled = true) {

        if ($institutionDropdown.hasClass("select2-hidden-accessible")) {
            $institutionDropdown.select2('destroy');
            $institutionDropdown.empty();
            $institutionDropdown.append($institutionDropdownDefaultOption);
        }

        $institutionDropdown.removeClass('js-hidden');

        if (disabled === false) {
            $institutionsSectionDropdown.removeAttr('disabled');
        }

        $institutionDropdown.select2({
            width: 'resolve',
            minimumInputLength: data.length >= 30 ? 3 : 0,
            disabled: disabled,
            data: data,
        });
    };

    const fetchInstitutions = function(countryCode) {
        const endpoint = $institutionDropdown.data('endpoint') + '/' + countryCode;

        $institutionsSectionDropdown.attr('disabled', 'disabled');

        $institutionsSectionDropdown.removeClass('closed');

        $.getJSON(endpoint, function(data) {
            const options = data.map(function(item) {
                return {
                    id: item.url,
                    text: item.name
                };
            })

            initInstitutionDropdown(options, false);
        });
    };

    const initCountryDropdown = function() {

        const formatCountry = function (country) {
            if (!country.id) {
                return country.text;
            }

            const countryIcon = `https://hatscripts.github.io/circle-flags/flags/${country.id.toLowerCase()}.svg`;

            const $country = $(
                '<span class="country-option"><img src="' + countryIcon + '" /><span>' + country.text + '</span></span>'
            );
            return $country;
        }

        $countryDropdown.removeClass('js-hidden');
        $countryDropdown.select2();

        $.getJSON($countryDropdown.data('endpoint'), function(data) {
            $countryDropdown.select2({
                templateResult: formatCountry,
                templateSelection: formatCountry,
                data: data.results,
            });

            $countryDropdown.on('select2:open', () => {
                document.querySelector('.select2-search__field').focus();
            });

            $countryDropdown.on('select2:select', (e) => {
                const countryCode = e.params.data.id;
                fetchInstitutions(countryCode);
            });

            $countryDropdown.trigger('change');
            $('.institutions__select--country').removeAttr('disabled');
        });
    };

    $(function() {

        // add [disabled] attribute to institution dropdown

        switch (config) {
            case 'hidden':
                $institutionsSectionDropdown.addClass('institutions--section-dropdown--hidden');
                break;

            default:
                $institutionsSectionDropdown.addClass('institutions--section-dropdown--disabled');
                break;
        }

        $form.removeClass('js-hidden');
        $institutionsSectionDropdown.removeClass('js-hidden');
        initCountryDropdown();
        initInstitutionDropdown();

        // Update select2 width on screen resize.
        $(window).on('resize', function() {
            $('.institutions__select').each(function() {
                const fieldWidth = $(this).outerWidth();
                $(this).find('.select2-container').css('width', fieldWidth);
            });
        });

        $form.on('submit', function(e) {
            e.preventDefault();

            let messageBlock = $(this).find('div.messaging');

            if (!messageBlock.hasClass('js-hidden')) {
                messageBlock.addClass('js-hidden');
            }

            var url = $(this).find('select[name="institution"]').children("option:selected").val();

            if (url.length == 0) {
                $(this).find('div.messaging').removeClass('js-hidden');
                return false;
            }

            document.location.assign(url);
        });
    });
})(window.FWSchoolDropdown);
